module.exports = __webpack_public_path__ + "img/gothCity.e69800ec.jpg";